import React from 'react'
import './StoryBody.css'
import StoryContent from './StoryContent'

type Props = {
  contents: storyContent[]
}
export default function StoryBody(props: Props) {
  return (
    <ol>
      { props.contents.map((content, i) => {
        return (
          <StoryContent key={i} content={content} />
        )
      })}
    </ol>
  )
}
